import SearchPageContainer from '../../client/containers/searchPageContainer'
import { IRouteConfig, PageType } from '../../typings/routes'

export const newSearchRouteConfig: IRouteConfig[] = [
  {
    path: '/all-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/all-graphics',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/graphics-with-:term-in-:category([\\w/-]+)/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/graphics-with-:term-in-:category([\\w/-]+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-and-:tags-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/:term-and-:tags-graphics',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:tags-graphics-in-:category([\\w/-]+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-in-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.SEARCH
  },
  {
    path: '/:term-in-graphics',
    component: SearchPageContainer,
    pageType: PageType.SEARCH
  },
  {
    path: '/:tags-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/:tags-graphics',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/attributes/:attribute_key/:attribute_value',
    component: SearchPageContainer,
    pageType: PageType.ATTRIBUTE
  },
  {
    path: '/:category+/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:category+',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  }
]

export const oldSearchRouteConfig: IRouteConfig[] = [
  {
    component: SearchPageContainer,
    path: '/category/*',
    pageType: PageType.CATEGORY
  },
  {
    component: SearchPageContainer,
    path: '/tags/:tags',
    pageType: PageType.TAG
  },
  {
    component: SearchPageContainer,
    path: '/attributes/:key/:value',
    pageType: PageType.ATTRIBUTE
  },
  {
    component: SearchPageContainer,
    path: '/search',
    pageType: PageType.SEARCH
  }
]
